import React, { useEffect } from 'react';
import styled from 'styled-components';
import 'objectFitPolyfill';
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';
import { LocalizedProduct } from 'models/products';

const ProductItemContainer = styled(Link)`
  min-height: 300px;
  width: 330px;
  padding: 16px;
  margin: 8px 16px;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background-color: #FFF;
  align-self: initial;
  text-decoration: initial;
  color: initial;

  @media (max-width: 360px) {
    width: 100%;
  }

  @media (min-width: 960px) {
    background-color: rgba(255, 255, 255, 0.9);
    transition: background-color 0.2s;
    &:hover {
      background-color: rgba(255, 255, 255, 1);
    }
  }
`;

const ProductImageContainer = styled.div`
  position: relative;
  height: 0;
  padding-top: 100%;
`;

const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: contain;
`;

const ProductTagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

declare global {
  interface Window {
    objectFitPolyfill: () => unknown;
  }
}

const ProductTag = styled.div`
  margin: 8px;
  border-radius: 8px;
  padding: 8px;
  font-size: 0.75em;
  background-color: #E0E0E0;
  color: #484848;
  font-weight: bold;
`;

const ProductSpacer = styled.div`
  display: flex;
  flex-grow: 1;
`;

const ProductItemTags = ({ tags }: { tags: string[] }) => (
  <ProductTagsContainer>
    {tags.map((tagName) => (
      <ProductTag key={tagName}>
        {`#${tagName}`}
      </ProductTag>
    ))}
  </ProductTagsContainer>
);

const ProductItem = ({
  product: {
    id,
    image,
    name,
    tags = [],
    oneLiner,
  },
  className,
}: {
  product: LocalizedProduct;
  className?: string;
}) => {
  useEffect(() => {
    window.objectFitPolyfill();
  });

  return (
    <ProductItemContainer to={`/products/${id}`} className={className}>
      <ProductImageContainer>
        <ProductImage
          src={image?.originalImageUrl}
          data-object-fit="contain"
          data-object-position="center"
        />
      </ProductImageContainer>
      <h4>{name}</h4>
      <div>{ReactHtmlParser(oneLiner)}</div>
      <ProductSpacer />
      <ProductItemTags tags={tags} />
    </ProductItemContainer>
  );
};

export default ProductItem;
